module.exports = __webpack_public_path__ + "img/doKument_logo_3.0b423f80.png";